import { CherryPayApi } from "../../api/models";
import { useMemo } from "react";

export const useGetSaveButtonTheme = (
  event?: CherryPayApi.Event | null
): string | undefined => {
  return useMemo(() => {
    if (!event) {
      return undefined;
    }

    if (event.EventStatus == "Draft") {
      return undefined;
    } else {
      return "cherryButton";
    }
  }, [event]);
};

export const useGetSaveButtonLabel = (
  event?: CherryPayApi.Event | null
): string | undefined => {
  return useMemo(() => {
    if (!event) {
      return "Save Draft";
    }

    if (event.EventStatus == "Draft") {
      return "Save Draft";
    } else {
      return "Save";
    }
  }, [event]);
};

export const useCanPublishEvent = (
  event?: CherryPayApi.Event | null
): boolean => {
  return useMemo(() => {
    if (!event) {
      return true;
    }

    return event.EventStatus == "Draft";
  }, [event]);
};
